import { useToast } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useCountdownTimer from 'src/shared/hooks/useCountdownTimer'
import { recoverPasswordApi } from '../../apis/recoverPasswordApi'
import { confirmNewPasswordApi } from '../../apis/redefinePassword'
import { useIamStore } from '../../apis/store'

const useNewPasswordRequired = () => {
  const [t] = useTranslation()
  const { userEmail, sendEvent } = useIamStore((state) => ({ userEmail: state.userEmail, sendEvent: state.sendEvent }))
  const { timer, resetTimer, isCounting } = useCountdownTimer({ countdown: 30 })
  const toast = useToast()
  const [isLoading, setLoading] = React.useState(false)
  const sendRecoverPasswordEmail = React.useCallback(() => {
    setLoading(true)
    recoverPasswordApi({ email: userEmail })
      .then(() => {
        setLoading(false)
        toast({
          title: t('login.resetPassword.E-mail successfully sent'),
          isClosable: true,
          duration: 5000,
          status: 'success',
        })
        resetTimer()
      })
      .catch(() => {
        setLoading(false)
        toast({
          title: t('login.validation.Something went wrong'),
          isClosable: true,
          duration: 5000,
          status: 'error',
        })
      })
  }, [resetTimer, t, toast, userEmail])
  const confirmNewPassword = React.useCallback(
    (data: { email: string; code: string; password: string }) => {
      setLoading(true)
      confirmNewPasswordApi(data)
        .then(() => {
          setLoading(false)
          toast({
            title: t('login.redefinePassword.success'),
            isClosable: true,
            duration: 5000,
            status: 'success',
          })
          sendEvent({ type: 'VALID_PASSWORD' })
        })
        .catch(() => {
          setLoading(false)
          toast({
            title: t('login.validation.Something went wrong'),
            isClosable: true,
            duration: 5000,
            status: 'error',
          })
        })
    },
    [toast, sendEvent, t],
  )
  return { isLoading, email: userEmail, confirmNewPassword, sendRecoverPasswordEmail, timer, isCounting }
}

export default useNewPasswordRequired
